import { Button, Card, Space, Table, Tabs } from "@arco-design/web-react";
import { IconPlus } from "@arco-design/web-react/icon";
import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { InvAdjustmentOrderAPI, InvMovementOrderAPI } from "@/apis/material";
import { formatDate } from "@/utils";
import { Number, Currency } from "@/components/Numeric";
import { InvAdjustmentAdd } from "./inv-adjustment-add";
import { InvAdjustmentInfo } from "./inv-adjustment-info";
import { InvNewInventoryAdd } from "./inv-new-inventory-add";
import { InvMovementAdd } from "./inv-movement-add";
import { InvMovementInfo } from "./inv-movement-info";
import { InvNewInventoryInfo } from "./inv-new-inventory-info";
import { InvAdjustmentOrderType } from "@/enums/material";

const { TabPane } = Tabs;

const AdjustmentTab = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState();

    const fetchData = useCallback(async () => {
        const res = await InvAdjustmentOrderAPI.query({ page });
        setData(res.records);
        setPagination((prev) => ({
            ...prev,
            current: page,
            total: res.total
        }));
    }, [page]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const columns = [
        {
            title: "ID", dataIndex: "adjustmentNo",
            render: (col, record) => {
                const to = record.orderType === InvAdjustmentOrderType.NewInventory
                    ? `/workspace/material/inventory_new_inventory/${record.id}`
                    : `/workspace/material/inventory_adjustment/${record.id}`;
                return <Link to={to}>{record.adjustmentNo}</Link>;
            }
        },
        {
            title: "Date", dataIndex: "createTime",
            render: (val) => val ? formatDate(val) : ""
        },
        {
            title: "Qty", dataIndex: "totalQty",
            render: (val) => val != null ? <Number value={val} /> : ""
        },
        {
            title: "Amount", dataIndex: "adjustmentValue",
            render: (val) => val != null ? <Currency value={val} /> : ""
        },
        {
            title: "Note", dataIndex: "notes"
        }
    ];

    return (
        <Card>
            <Space style={{ marginBottom: 16 }}>
                <Button type="primary" icon={<IconPlus />} onClick={() => navigate("/workspace/material/inventory_adjustment/new")}>New Inventory Adjustment</Button>
                <Button type="primary" icon={<IconPlus />} onClick={() => navigate("/workspace/material/inventory_adjustment/new_inventory")}>Add New Inventory</Button>
            </Space>
            <Table
                columns={columns}
                rowKey="id"
                data={data}
                pagination={pagination}
                onChange={(pag) => setPage(pag.current)}
            />
        </Card>
    );
};

const MovementTab = () => {
    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState();

    const fetchData = useCallback(async () => {
        const res = await InvMovementOrderAPI.query({ page });
        setData(res.records);
        setPagination((prev) => ({
            ...prev,
            current: page,
            total: res.total
        }));
    }, [page]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const columns = [
        {
            title: "ID", dataIndex: "movementNo",
            render: (col, record) => <Link to={`/workspace/material/inventory_movement/${record.id}`}>{record.movementNo}</Link>
        },
        {
            title: "Date", dataIndex: "createTime",
            render: (val) => val ? formatDate(val) : ""
        },
        {
            title: "Note", dataIndex: "notes"
        }
    ];

    return (
        <Card>
            <Space style={{ marginBottom: 16 }}>
                <Button type="primary" icon={<IconPlus />} onClick={() => navigate("/workspace/material/inventory_movement/new")}>New Inventory Movement</Button>
            </Space>
            <Table
                columns={columns}
                rowKey="id"
                data={data}
                pagination={pagination}
                onChange={(pag) => setPage(pag.current)}
            />
        </Card>
    );
};

export const InventoryAdjustment = () => {
    return (
        <Card>
            <Tabs defaultActiveTab="adjustment">
                <TabPane key="adjustment" title="Inventory Adjustment">
                    <AdjustmentTab />
                </TabPane>
                <TabPane key="movement" title="Inventory Movement">
                    <MovementTab />
                </TabPane>
            </Tabs>
        </Card>
    );
}

InventoryAdjustment.Add = InvAdjustmentAdd;
InventoryAdjustment.Info = InvAdjustmentInfo;
InventoryAdjustment.NewInventoryAdd = InvNewInventoryAdd;
InventoryAdjustment.NewInventoryInfo = InvNewInventoryInfo;
InventoryAdjustment.MovementAdd = InvMovementAdd;
InventoryAdjustment.MovementInfo = InvMovementInfo;

export { InvAdjustmentAdd, InvAdjustmentInfo, InvNewInventoryAdd, InvNewInventoryInfo, InvMovementAdd, InvMovementInfo };
